import UnvalidatedForm from  "../../lib/iprs-react-library/src/Form/UnvalidatedForm";

/**
 * This is a wraaper for the UnvalidatedForm component.
 * It takes the appState and values from the parent component.
 * This has been copied into the Diary project to ease maintainance.
 * @param {*} props 
 * @returns 
 */
const Form = ({ appState, values, handleChange, api, validating}) => {

    const { websiteConfig: { ReferralForm: {Fields}, 
        formDataValues: formFieldData, DataSourceValues }, Client } = appState;

    const dataSources = DataSourceValues?.[Client?.ClientPartyID];

    // take out datasources identified by a datasourceID
    const fieldDefinitions = Fields.map(f => ({
        ...f,
        Options: Array.isArray(dataSources?.[f.DataSourceID])
            ? dataSources?.[f.DataSourceID]
            : f.Options
    }));

    const props = {validating, fieldDefinitions, formFieldData: values, api, onChange: handleChange};

    return <UnvalidatedForm {...props} />
}

export default Form;